module.exports = __webpack_public_path__ + "img/fla1.6a5df8b3.jpg";